import { Link } from "react-router";
import api from "../../api/client";

export const AdminHub = () => {
  const shortcuts = [
    {
      title: "Edit Schedule",
      desc: "Add, edit, cancel, or duplicate stops for the week.",
      to: "/admin/schedule",
      badge: "Schedule",
    },
    {
      title: "Edit Menu",
      desc: "Update menu items, prices, availability, and categories.",
      to: "/admin/menu",
      badge: "Menu",
    }
  ];

  async function downloadContacts() {
    try {
      const res = await api.get("/contacts", { raw: true });
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "contacts.csv";
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      alert("Failed to download contacts.");
    }
  }

  return (
    <div className="ah-wrap">
      <header className="ah-header">
        <div>
          <h1 className="ah-title">Admin Hub</h1>
          <p className="ah-subtitle">Quick access to admin workflows.</p>
        </div>

        <div className="ah-actions">
          <Link className="ah-btn" to="/">
            View Site
          </Link>
        </div>
      </header>

      <section className="ah-grid" aria-label="Admin shortcuts">
        {shortcuts.map((s) => (
          <Link key={s.title} to={s.to} className="ah-card" aria-label={`Open ${s.title}`}>
            <div className="ah-cardInner">
              <div className="ah-cardTop">
                <span className="ah-badge">{s.badge}</span>
              </div>
              <h2 className="ah-cardTitle">{s.title}</h2>
              <p className="ah-cardDesc">{s.desc}</p>
              <div className="ah-cardFooter">
                <span className="ah-cardLink">Open →</span>
              </div>
            </div>
          </Link>
        ))}

        <button type="button" className="ah-card" onClick={downloadContacts}>
          <div className="ah-cardInner">
            <div className="ah-cardTop">
              <span className="ah-badge">Contacts</span>
            </div>
            <h2 className="ah-cardTitle">Export Contacts</h2>
            <p className="ah-cardDesc">Download the mailing list as a CSV file.</p>
            <div className="ah-cardFooter">
              <span className="ah-cardLink">Download ↓</span>
            </div>
          </div>
        </button>
      </section>
    </div>
  );
};
